<template>
    <slide-up-modal
        v-if="modalDisplayed"
        ref="beforeSignFormModal"
        modal-id="beforeSignFormModal"
        modal-title="Signature électronique du contrat"
        @modal-closed="hideModal"
    >
        <div class="text-danger">
            <p style="font-weight: bold;">IMPORTANT !</p>

            <p>Le client a-t-il bien fourni l’ensemble des documents justificatifs demandés ?</p>

            <ul>
                <li style="list-style: disc inside none; line-height: 1.35; margin-bottom: 5px;">
                    Si votre réponse ci-dessus est « non » , ne continuez pas : le client recevrait par email 
                    la version signée du contrat à la fin de cette procédure.
                </li>
                <li style="list-style: disc inside none; line-height: 1.35;">
                    Si votre réponse est « oui », assurez-vous que le client a bien signé le document avant vous 
                    en cliquant sur « Consulter et signer le contrat » . Aller au bas de la dernière page du contrat. 
                    Si c’est bien le cas, vous pouvez accepter la signature électronique.
                    <br><br><span style="font-weight: bold;">Attention, pas d’annulation possible après contre-signature !</span>
                    <br>Une fois que le contrat est contre-signé par Sofradom, le client doit impérativement 
                    être descendu dans SAP dans la foulée (Résoudre / Valider) : Ceci permet au contrat d’être disponible 
                    au téléchargement depuis l’espace client au bout de quelques minutes.
                </li>
            </ul>
        </div>

        <div style="margin-top: 20px;">
            <a v-if="digitalContract && !digitalContract.is_final_state && digitalContract.form_link"
                :href="digitalContract.form_link" 
                tag="button" 
                class="btn btn-primary btn-sm" 
                target="_blank" 
                @click="hideModal"
            >
                <span>Consulter et signer le contrat</span>
            </a>

            <button @click="hideModal" class="btn btn-default btn-sm">Annuler</button>
        </div>
    </slide-up-modal>
</template>

<script>
    import SlideUpModal from 'components/Modals/SlideUpModal'

    export default {
        data() {
            return {
                modalDisplayed: false
            }
        },

        props: ['digitalContract'],

        components: {
            SlideUpModal
        },

        methods: {
            displayModal() {
                this.modalDisplayed = true
            },

            hideModal() {
                this.modalDisplayed = false
            },

            displayModalLoader() {
                this.$refs.voidFormModal.isLoading = true
            },

            hideModalLoader() {
                this.$refs.voidFormModal.isLoading = false
            }
        }
    }
</script>


// WEBPACK FOOTER //
// client/components/Customer/InformationsContent/Contracts/DigitalSignature/BeforeSignModal.vue